import requests from 'api/index';

const prefixURL = '/employee/memberadmin';
export default {
  getNationList: payload => requests.get(`${prefixURL}/rest/v2/nosession/cntry?noSessionPrc=Y&langCd=${payload}`),
  getTermsContents: payload => requests.get(`${prefixURL}/rest/v2/nosession/terms/cn?${payload}`),
  getTermsVersion: payload => requests.get(`${prefixURL}/rest/v2/nosession/terms/version?${payload}`),
  getCountryTerms: payload => requests.get(`${prefixURL}/rest/v2/nosession/cntry/terms/cn?${payload}`),
  createTermsAgreement: payload => requests.post(`${prefixURL}/rest/v2/nosession/terms/agmt?noSessionPrc=Y`, payload),
  updateEmployee: payload => requests.post(`${prefixURL}/rest/v1/emp/nosession/update?noSessionPrc=Y`, payload),
  checkOtp: payload => requests.post(`${prefixURL}/rest/v1/id/nosession/checkOTP?noSessionPrc=Y`, payload),
  checkPassword: payload => requests.post(`${prefixURL}/rest/v1/page/nosession/check?noSessionPrc=Y`, payload),
  updatePrivacy: payload => requests.post(`${prefixURL}/rest/v1/id/nosession/privacy/update?noSessionPrc=Y`, payload),
  getNosessionProperty: payload =>
    requests.get(`/employee/empsearch/rest/v1/nosession/property?noSessionPrc=Y&key=${payload}`),
  getTermsVersionCntryCd: payload =>
    requests.get(`${prefixURL}/rest/v2/nosession/terms/policy/version?noSessionPrc=Y&cntryCd=${payload}`),
};
